var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mx-2",attrs:{"fab":"","dark":"","x-small":"","color":"green lighten-1"},on:{"click":function($event){return _vm.$emit('step', $event)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n        mdi-file-document-edit\n    ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a68fdf6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/customwidgets/EditButton.vue
// module id = null
// module chunks = 